module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_person-10e95d4872d8937b8030cb622be82768.svg";